import type { BaseReactProps, ReactNodeDef } from '@shared/node-v1.0.0'
import { getPortDef, margins, paddings, sizes } from '@shared/port-v1.0.0'

export type Props = BaseReactProps & { grow: boolean; wrap: boolean }

import Comp from '../component'

export default {
	module: { static: Comp },
	inNode: {
		inputs: [
			getPortDef({ name: 'grow', displayName: 'Grow', group: 'Dimensions', type: 'boolean', default: false }),
			getPortDef({ name: 'w', displayName: 'Width', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'h', displayName: 'Height', group: 'Dimensions', type: 'string' }),
			getPortDef({ name: 'wrap', displayName: 'Wrap', group: 'Layout', type: 'boolean', default: true }),
			getPortDef({
				name: 'align',
				displayName: 'Align',
				group: 'Layout',
				type: [
					{ label: 'Stretch', value: 'stretch' },
					{ label: 'Center', value: 'center' },
					{ label: 'Flex start', value: 'flex-start' },
					{ label: 'Flex end', value: 'flex-end' },
				],
				default: 'flex-start',
			}),
			getPortDef({
				name: 'justify',
				displayName: 'Justify',
				group: 'Layout',
				type: [
					{ label: 'Center', value: 'center' },
					{ label: 'Flex start', value: 'flex-start' },
					{ label: 'Flex end', value: 'flex-end' },
					{ label: 'Space between', value: 'space-between' },
				],
				default: 'flex-start',
			}),
			getPortDef({
				name: 'gap',
				displayName: 'Gap*',
				group: 'Layout',
				type: [{ value: '0', label: 'none' }, ...sizes],
				default: 'md',
			}),
			getPortDef({
				name: 'preventGrowOverflow',
				displayName: 'Prevent grow overflow',
				group: 'Layout',
				type: 'boolean',
				default: true,
				dependsOn: (p: Props) => p.grow,
			}),
			getPortDef({ name: 'opacity', displayName: 'Opacity', group: 'Styles', type: 'number', default: 1 }),
			...margins,
			...paddings,
		],
	},
} satisfies ReactNodeDef
